'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

require('./SignUpForm.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validateEmail = function validateEmail(value) {
  var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return emailPattern.test(value);
};

var SignUpForm = function (_React$Component) {
  _inherits(SignUpForm, _React$Component);

  function SignUpForm() {
    _classCallCheck(this, SignUpForm);

    var _this = _possibleConstructorReturn(this, (SignUpForm.__proto__ || Object.getPrototypeOf(SignUpForm)).call(this));

    _this.state = {
      email: '',
      showError: false,
      showSuccess: false,
      showInvalidEmail: false,
      showLoader: false
    };
    return _this;
  }

  _createClass(SignUpForm, [{
    key: 'onEmailChange',
    value: function onEmailChange(e, data) {
      /* onEmailChange sets showInvalidEmail only to false to prevent the
      error styling from appearing when the user starts typing. */
      var isValid = validateEmail(data.value);
      var emailValidation = isValid ? { showInvalidEmail: !isValid } : {};
      this.setState(_extends({}, emailValidation, { email: data.value }));
    }
  }, {
    key: 'onSubmitEmail',
    value: function onSubmitEmail() {
      var _this2 = this;

      if (validateEmail(this.state.email)) {
        this.setState({ showLoader: true });
        this.props.subscriptionCallback(this.state.email).then(function () {
          return _this2.toggleValidation('showSuccess');
        }).catch(function () {
          return _this2.toggleValidation('showError');
        });
      } else this.toggleValidation('showInvalidEmail');
    }
  }, {
    key: 'getValidationContent',
    value: function getValidationContent() {
      var _this3 = this;

      var _props = this.props,
          buttonLabel = _props.buttonLabel,
          buttonColor = _props.buttonColor;
      var _state = this.state,
          showError = _state.showError,
          showSuccess = _state.showSuccess,
          showInvalidEmail = _state.showInvalidEmail,
          showLoader = _state.showLoader;

      if (showLoader) {
        return {
          content: _react2.default.createElement(
            'div',
            { className: 'loader' },
            'One Moment Please',
            _react2.default.createElement(
              'span',
              null,
              '.'
            ),
            _react2.default.createElement(
              'span',
              null,
              '.'
            ),
            _react2.default.createElement(
              'span',
              null,
              '.'
            )
          ),
          color: buttonColor
        };
      }
      var color = showInvalidEmail || showError ? 'red' : buttonColor;
      var content = showInvalidEmail ? 'Invalid Email' : showError ? 'Please Try Again!' : buttonLabel;
      return showSuccess ? { content: 'Thank you!', color: 'green' } : { color: color, content: content, onClick: function onClick() {
          return _this3.onSubmitEmail();
        } };
    }
  }, {
    key: 'toggleValidation',
    value: function toggleValidation(error) {
      var _extends2,
          _this4 = this;

      var resetText = error === 'showSuccess' || error === 'showError' ? { email: '' } : {};
      this.setState(_extends({}, resetText, (_extends2 = {}, _defineProperty(_extends2, error, true), _defineProperty(_extends2, 'showLoader', false), _extends2)));
      if (error === 'showError') {
        setTimeout(function () {
          _this4.setState({ showError: false });
        }, 2000);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props2 = this.props,
          fluid = _props2.fluid,
          placeholder = _props2.placeholder,
          className = _props2.className;
      var _state2 = this.state,
          email = _state2.email,
          showError = _state2.showError,
          showSuccess = _state2.showSuccess,
          showInvalidEmail = _state2.showInvalidEmail;

      var label = this.getValidationContent();
      return _react2.default.createElement(_semanticUiReact.Input, {
        fluid: fluid,
        className: 'sign-up-form ' + className,
        error: showInvalidEmail || showError,
        placeholder: showSuccess ? 'You\'re Subscribed!' : showError ? 'Server Error' : placeholder,
        action: label,
        onChange: function onChange(e, data) {
          return _this5.onEmailChange(e, data);
        },
        value: email,
        onKeyPress: function onKeyPress(e) {
          return e.key === 'Enter' ? _this5.onSubmitEmail() : function () {
            return null;
          };
        }
      });
    }
  }]);

  return SignUpForm;
}(_react2.default.Component);

exports.default = SignUpForm;


SignUpForm.propTypes = {
  fluid: _propTypes2.default.bool,
  buttonColor: _propTypes2.default.string,
  buttonLabel: _propTypes2.default.string,
  subscriptionCallback: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string,
  className: _propTypes2.default.string
};

SignUpForm.defaultProps = {
  fluid: false,
  buttonColor: 'blue',
  buttonLabel: 'Follow Us!',
  placeholder: 'Join our mailing list!',
  className: ''
};


//////////////////
// WEBPACK FOOTER
// ./~/@fishrmn/fishrmn-components/build/components/molecules/SignUpForm/SignUpForm.js
// module id = 498
// module chunks = 168707334958949